<template>
  <v-container fluid>
    <v-card class="pa-6">
      <v-row>
        <v-col cols="12" md="8">
          <v-card-title class="text-h5"
            >Immigration Master Work Place of issue List</v-card-title
          >
        </v-col>
        <v-col align="right" color="primary" cols="12" md="4">
          <v-btn
            to="/im-master-workplaceofissue-list-add/Add/0"
            color="#0A7EA5"
            rounded
            dark
            class="mb-2"
            v-if="authorize_add"
          >
            <span>Add</span>
            <v-icon small center>add</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            class="widthsizesearch"
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            outlined
            dense
            @keyup.enter="findAllByAPISearch"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end mb-6"> </v-col>
      </v-row>

      <br />

      <v-card outlined tile class="mt-2">
        <!-- <v-data-table
          dense
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="elevation-1   595959"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              v-if="authorize_edit"
              :style="{
                backgroundColor: '#E1F5FE',
                color: '#254E58',
              }"
              @click="openeditItem(item.id)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              v-if="authorize_del"
              class="ml-5"
              :style="{
                backgroundColor: '#FFEBEE',
                color: '#9E3B1B',
              }"
              @click="deleteItem(item.id)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table> -->

        <!-- Pagination Section -->
        <div>
          <v-select
            v-model="itemsPerPage"
            @change="onSearchPagination"
            style="width: 150px"
            :items="item_per_page_list"
            label="Items per page"
            dense
            outlined
            hide-details
          ></v-select>
        </div>
        <div>
          <div class="text-center pt-2">
            <v-pagination
              class="ma-3"
              v-model="page"
              :length="pageCount"
              @input="loadDataByPage"
              total-visible="19"
            ></v-pagination>
          </div>

          <v-data-table
            :headers="headers"
            :items="mDataArray2"
            :server-items-length="totalItems"
            :options.sync="options"
            @update:options="onOptionsUpdate"
            hide-default-footer
            class="elevation-1"
            :loading="tableLoading"
            loading-text="Loading... Please wait"
          >
            <!-- <v-data-table
            :headers="headers"
            :items="filteredData"
            :server-items-length="filteredData.length"
            :options.sync="options"
            @update:options="onOptionsUpdate"
            hide-default-footer
            class="elevation-1"
            :loading="tableLoading"
            loading-text="Loading... Please wait"
          > -->
            <!-- Custom loading slot สำหรับแสดง loading แบบวงกลม -->
            <template v-slot:progress>
              <div class="text-center pa-6">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="50"
                  width="8"
                ></v-progress-circular>
                <div class="mt-3 text-subtitle-1 primary--text">
                  กำลังโหลดข้อมูล...
                </div>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                v-if="authorize_edit"
                :style="{
                  backgroundColor: '#E1F5FE',
                  color: '#254E58',
                }"
                @click="openeditItem(item.id)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                v-if="authorize_del"
                class="ml-5"
                :style="{
                  backgroundColor: '#FFEBEE',
                  color: '#9E3B1B',
                }"
                @click="deleteItem(item.id)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-card>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >Are you sure you want to delete this item?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    />

    <SuccessDialogPush
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
      :link="link"
    />
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "@/services/constants";
import unity from "@/unity/unity";

export default {
  name: "SO-list",
  data(vm) {
    return {
      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      id_del: 0,
      search: "",
      dialogDelete: false,
      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      toggleEnable: false,
      selectstatus: "",
      mDataArray: [],
      authorize: [],
      headers: [
        {
          text: "Title",
          value: "title",
          class: "bg-colorth tabletextwhite",
          align: "start",
          divider: true,
        },
        {
          text: "",
          value: "actions",
          align: "center",
          class: "bg-colorth tabletextwhite",
          divider: true,
        },
      ],
    };
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  beforeUpdate() {},
  components: {
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {
    filteredData() {
      if (!this.search) {
        return this.mDataArray2;
      }

      const searchLower = this.search.toLowerCase();
      return this.mDataArray2.filter((item) => {
        // ค้นหาจากทุก field ที่อยู่ใน headers (ยกเว้น actions)
        return this.headers.some((header) => {
          if (header.value === "actions") return false;
          const value = item[header.value];
          return (
            value &&
            value
              .toString()
              .toLowerCase()
              .includes(searchLower)
          );
        });
      });
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    if (!this.authorize_view) {
      this.$router.back();
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }

    //load data
    await this.loaddata();
    this.$hideLoader();
  },
  methods: {
    // 1. เพิ่มฟังก์ชัน findAllByAPISearch
    async findAllByAPISearch() {
      await this.onSearchPagination();
    },

    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      /*
          page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id,
        search
     */

      try {
        const result = await api.getImMasterWorkPlaceofissueByCompany_Dep_Pagination(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          localStorage.getItem(server.DEPARTMENT_ID),
          this.search
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "DESC";
      } else {
        sortDesc = "ASC";
      }

      /*
          page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id,
        search
     */

      try {
        const result = await api.getImMasterWorkPlaceofissueByCompany_Dep_Pagination(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          localStorage.getItem(server.COMPANYID),
          localStorage.getItem(server.DEPARTMENT_ID),
          this.search
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];

      /*
          page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id,
        search
     */

      try {
        const result = await api.getImMasterWorkPlaceofissueByCompany_Dep_Pagination(
          pageNumber,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          localStorage.getItem(server.DEPARTMENT_ID),
          this.search
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.tableLoading = true;

      /*
          page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id,
        search
     */

      var s_data = {
        page: 1,
        limit: this.itemsPerPage,
        sortBy: "id",
        sortOrder: "ASC",
        company_id: localStorage.getItem(server.COMPANYID),
        department_id: localStorage.getItem(server.DEPARTMENT_ID),
        search: this.search,
      };

      try {
        const result = await api.getImMasterWorkPlaceofissueByCompany_Dep_Pagination(
          s_data.page,
          s_data.limit,
          s_data.sortBy,
          s_data.sortOrder,
          s_data.company_id,
          s_data.department_id,
          s_data.search
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    async loaddata() {
      const res_result = await api.getImMasterWorkPlaceofissueByCompany_Dep({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
          department_id: localStorage.getItem(server.DEPARTMENT_ID),
        },
      });
      this.mDataArray = res_result.data;
      console.log(this.mDataArray);
    },
    async openeditItem(id) {
      this.$router.push(`/im-master-workplaceofissue-list-add/Edit/${id}`);
    },
    async deleteItem(id) {
      this.id_del = id;
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      this.dialogDelete = false;
      this.$showLoader();
      const res_del = await api.DeleteImMasterWorkPlaceofissue(this.id_del);
      if (res_del.status == 200) {
        await this.loaddata();
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ลบข้อมูล",
          "ลบข้อมูลสำเร็จ",
          "text-h5 green--text text-center"
        );
      } else {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ลบข้อมูล",
          "ไม่สามารถลบได้",
          "text-h5 red--text text-center"
        );
      }
    },
    async closeDelete() {
      this.dialogDelete = false;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
  },
};
</script>

<style scoped>
.bg-colorth {
  background-color: #595959;
  color: red;
}
.text-left {
  color: aliceblue;
}
.widthsizesearch {
  width: 70%;
}
.theme--light.v-card {
  border-color: white;
}
</style>
